import { Router } from '@angular/router';
import {LocalStorageService} from 'ngx-webstorage';
import { Input, Component, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(private router: Router, private storage: LocalStorageService) { }

  ngOnInit() {
    this.storage.observe('username').subscribe(
      data =>{
        this.username = this.storage.retrieve('username')
      }
    )
  }


  title = 'chat-poc2';
  username: string = ""
  logout(){
    this.router.navigateByUrl("login")
    this.storage.clear('username');
  }

  login(){
    this.router.navigateByUrl("login")
    this.storage.clear('username');
  }

  home(){
    this.router.navigateByUrl("home")
    this.storage.clear('username');
  }
}
